import RolesChecker from 'features/customer/components/RolesChecker';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import RequirementCreateSection from '../sections/RequirementCreateSection';

interface Props {
  type: string;
}

const RequirementCreate = (props: Props) => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");
  
  const { type } = useParams<Props>();
  
  return (
    <>
      <Header 
        title={t("requirementCreate.title")}
        includeBreadcrumbs
        links={[{ text: t("requirements.title"), to: "/requirements" }]}
      />
      <ModuleContent>
        <RolesChecker enabledRoles="Contributor">
          <RequirementCreateSection requirementType={type} />
        </RolesChecker>
      </ModuleContent>
    </>
  )
}

export default RequirementCreate;
